module.exports = __webpack_public_path__ + "static/NanumSquareR-05c46ab6133e58f7b2ddd2b169ab6842.ttf";